













import { Vue, Component, Prop } from 'vue-property-decorator';
import { mdbRow, mdbCol, mdbInput, mdbAlert, mdbIcon } from '@folky-tools/mdbvue';

@Component({
    components: {
        mdbRow,
        mdbCol,
        mdbInput,
        mdbAlert,
        mdbIcon
    }
})
export default class EditContactSettings extends Vue {
    @Prop() private contactSettings!: {};
}
